import {AutoRefreshButton} from "@/components/autoRefreshButton/AutoRefreshButton.tsx";
import {ToggleFullscreenButton} from "@/components/toggleFullscreenButton/ToggleFullscreenButton.tsx";
import {DashboardDefinition} from "@/lib/types/website.ts";
import {DashboardActionMenu} from "@/pages/dashboard/display/components/dashboardActionBar/DashboardActionMenu.tsx";
import {DashboardSaveAction} from "@/pages/dashboard/display/components/dashboardActionBar/DashboardSaveAction.tsx";

interface DashboardActionBarProps {
  unsaved: boolean;
  dashboardDef: DashboardDefinition;
  dashboardDefs: DashboardDefinition[];
  refreshRate?: number;
  setRefreshRate: (value: number | undefined) => void;
  doRefresh: () => void;
  setShowEditDashboardModal: (show: boolean) => void;
  onBeforeSaveNavigate: () => void;
}

export const DashboardActionBar = ({
  unsaved,
  dashboardDef,
  dashboardDefs,
  refreshRate,
  setRefreshRate,
  doRefresh,
  setShowEditDashboardModal,
  onBeforeSaveNavigate,
}: DashboardActionBarProps) => {
  return (
    <div className="d-flex flex-row gap-2">
      <DashboardSaveAction unsaved={unsaved} dashboardDef={dashboardDef} onBeforeNavigate={onBeforeSaveNavigate} />
      <AutoRefreshButton seconds={refreshRate} setSeconds={setRefreshRate} doRefresh={doRefresh} size={"large"} />
      <ToggleFullscreenButton size={"large"} />
      <DashboardActionMenu
        dashboardDef={dashboardDef}
        dashboardDefs={dashboardDefs}
        setShowEditDashboardModal={setShowEditDashboardModal}
      />
    </div>
  );
};
